/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentMetrics model module.
 * @module model/AgentMetrics
 * @version 1.0.0
 */
class AgentMetrics {
    /**
     * Constructs a new <code>AgentMetrics</code>.
     * エージェント一覧で表示する集計値（サーバ計算）。target_month 指定時は当月に限った値を返す。
     * @alias module:model/AgentMetrics
     */
    constructor() { 
        
        AgentMetrics.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentMetrics</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentMetrics} obj Optional instance to populate.
     * @return {module:model/AgentMetrics} The populated <code>AgentMetrics</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentMetrics();

            if (data.hasOwnProperty('total_proposal_count')) {
                obj['total_proposal_count'] = ApiClient.convertToType(data['total_proposal_count'], 'Number');
            }
            if (data.hasOwnProperty('total_user_read_count')) {
                obj['total_user_read_count'] = ApiClient.convertToType(data['total_user_read_count'], 'Number');
            }
            if (data.hasOwnProperty('total_matching_count')) {
                obj['total_matching_count'] = ApiClient.convertToType(data['total_matching_count'], 'Number');
            }
            if (data.hasOwnProperty('total_contract_application_count')) {
                obj['total_contract_application_count'] = ApiClient.convertToType(data['total_contract_application_count'], 'Number');
            }
            if (data.hasOwnProperty('proposal_user_read_rate')) {
                obj['proposal_user_read_rate'] = ApiClient.convertToType(data['proposal_user_read_rate'], 'Number');
            }
            if (data.hasOwnProperty('proposal_matching_rate')) {
                obj['proposal_matching_rate'] = ApiClient.convertToType(data['proposal_matching_rate'], 'Number');
            }
            if (data.hasOwnProperty('contract_application_rate')) {
                obj['contract_application_rate'] = ApiClient.convertToType(data['contract_application_rate'], 'Number');
            }
            if (data.hasOwnProperty('target_month_proposal_count')) {
                obj['target_month_proposal_count'] = ApiClient.convertToType(data['target_month_proposal_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_inflow_user_proposal_count')) {
                obj['target_month_inflow_user_proposal_count'] = ApiClient.convertToType(data['target_month_inflow_user_proposal_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_re_proposal_count')) {
                obj['target_month_re_proposal_count'] = ApiClient.convertToType(data['target_month_re_proposal_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_inflow_user_re_proposal_count')) {
                obj['target_month_inflow_user_re_proposal_count'] = ApiClient.convertToType(data['target_month_inflow_user_re_proposal_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_proposal_user_read_count')) {
                obj['target_month_proposal_user_read_count'] = ApiClient.convertToType(data['target_month_proposal_user_read_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_proposal_user_read_count_including_prev')) {
                obj['target_month_proposal_user_read_count_including_prev'] = ApiClient.convertToType(data['target_month_proposal_user_read_count_including_prev'], 'Number');
            }
            if (data.hasOwnProperty('target_month_proposal_matching_count')) {
                obj['target_month_proposal_matching_count'] = ApiClient.convertToType(data['target_month_proposal_matching_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_proposal_matching_count_including_prev')) {
                obj['target_month_proposal_matching_count_including_prev'] = ApiClient.convertToType(data['target_month_proposal_matching_count_including_prev'], 'Number');
            }
            if (data.hasOwnProperty('target_month_total_matching_count')) {
                obj['target_month_total_matching_count'] = ApiClient.convertToType(data['target_month_total_matching_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_contract_application_count')) {
                obj['target_month_contract_application_count'] = ApiClient.convertToType(data['target_month_contract_application_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_contract_application_count_including_prev')) {
                obj['target_month_contract_application_count_including_prev'] = ApiClient.convertToType(data['target_month_contract_application_count_including_prev'], 'Number');
            }
            if (data.hasOwnProperty('target_month_proposal_total_user_read_count')) {
                obj['target_month_proposal_total_user_read_count'] = ApiClient.convertToType(data['target_month_proposal_total_user_read_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_proposal_total_matching_count')) {
                obj['target_month_proposal_total_matching_count'] = ApiClient.convertToType(data['target_month_proposal_total_matching_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_match_rate_for_business_meeting')) {
                obj['target_month_match_rate_for_business_meeting'] = ApiClient.convertToType(data['target_month_match_rate_for_business_meeting'], 'Number');
            }
            if (data.hasOwnProperty('target_month_proposal_user_read_rate')) {
                obj['target_month_proposal_user_read_rate'] = ApiClient.convertToType(data['target_month_proposal_user_read_rate'], 'Number');
            }
            if (data.hasOwnProperty('target_month_proposal_inflow_user_user_read_count')) {
                obj['target_month_proposal_inflow_user_user_read_count'] = ApiClient.convertToType(data['target_month_proposal_inflow_user_user_read_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_proposal_inflow_user_user_read_rate')) {
                obj['target_month_proposal_inflow_user_user_read_rate'] = ApiClient.convertToType(data['target_month_proposal_inflow_user_user_read_rate'], 'Number');
            }
            if (data.hasOwnProperty('target_month_proposal_matching_rate')) {
                obj['target_month_proposal_matching_rate'] = ApiClient.convertToType(data['target_month_proposal_matching_rate'], 'Number');
            }
            if (data.hasOwnProperty('target_month_proposal_inflow_user_matching_count')) {
                obj['target_month_proposal_inflow_user_matching_count'] = ApiClient.convertToType(data['target_month_proposal_inflow_user_matching_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_proposal_inflow_user_matching_rate')) {
                obj['target_month_proposal_inflow_user_matching_rate'] = ApiClient.convertToType(data['target_month_proposal_inflow_user_matching_rate'], 'Number');
            }
            if (data.hasOwnProperty('target_month_contract_application_rate')) {
                obj['target_month_contract_application_rate'] = ApiClient.convertToType(data['target_month_contract_application_rate'], 'Number');
            }
            if (data.hasOwnProperty('target_month_access_count')) {
                obj['target_month_access_count'] = ApiClient.convertToType(data['target_month_access_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_daily_average_access_count')) {
                obj['target_month_daily_average_access_count'] = ApiClient.convertToType(data['target_month_daily_average_access_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_contract_inflow_user_application_count')) {
                obj['target_month_contract_inflow_user_application_count'] = ApiClient.convertToType(data['target_month_contract_inflow_user_application_count'], 'Number');
            }
            if (data.hasOwnProperty('target_month_contract_inflow_user_application_rate')) {
                obj['target_month_contract_inflow_user_application_rate'] = ApiClient.convertToType(data['target_month_contract_inflow_user_application_rate'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentMetrics</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentMetrics</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} total_proposal_count
 */
AgentMetrics.prototype['total_proposal_count'] = undefined;

/**
 * @member {Number} total_user_read_count
 */
AgentMetrics.prototype['total_user_read_count'] = undefined;

/**
 * @member {Number} total_matching_count
 */
AgentMetrics.prototype['total_matching_count'] = undefined;

/**
 * @member {Number} total_contract_application_count
 */
AgentMetrics.prototype['total_contract_application_count'] = undefined;

/**
 * @member {Number} proposal_user_read_rate
 */
AgentMetrics.prototype['proposal_user_read_rate'] = undefined;

/**
 * @member {Number} proposal_matching_rate
 */
AgentMetrics.prototype['proposal_matching_rate'] = undefined;

/**
 * @member {Number} contract_application_rate
 */
AgentMetrics.prototype['contract_application_rate'] = undefined;

/**
 * @member {Number} target_month_proposal_count
 */
AgentMetrics.prototype['target_month_proposal_count'] = undefined;

/**
 * @member {Number} target_month_inflow_user_proposal_count
 */
AgentMetrics.prototype['target_month_inflow_user_proposal_count'] = undefined;

/**
 * @member {Number} target_month_re_proposal_count
 */
AgentMetrics.prototype['target_month_re_proposal_count'] = undefined;

/**
 * @member {Number} target_month_inflow_user_re_proposal_count
 */
AgentMetrics.prototype['target_month_inflow_user_re_proposal_count'] = undefined;

/**
 * @member {Number} target_month_proposal_user_read_count
 */
AgentMetrics.prototype['target_month_proposal_user_read_count'] = undefined;

/**
 * @member {Number} target_month_proposal_user_read_count_including_prev
 */
AgentMetrics.prototype['target_month_proposal_user_read_count_including_prev'] = undefined;

/**
 * @member {Number} target_month_proposal_matching_count
 */
AgentMetrics.prototype['target_month_proposal_matching_count'] = undefined;

/**
 * @member {Number} target_month_proposal_matching_count_including_prev
 */
AgentMetrics.prototype['target_month_proposal_matching_count_including_prev'] = undefined;

/**
 * @member {Number} target_month_total_matching_count
 */
AgentMetrics.prototype['target_month_total_matching_count'] = undefined;

/**
 * @member {Number} target_month_contract_application_count
 */
AgentMetrics.prototype['target_month_contract_application_count'] = undefined;

/**
 * @member {Number} target_month_contract_application_count_including_prev
 */
AgentMetrics.prototype['target_month_contract_application_count_including_prev'] = undefined;

/**
 * @member {Number} target_month_proposal_total_user_read_count
 */
AgentMetrics.prototype['target_month_proposal_total_user_read_count'] = undefined;

/**
 * @member {Number} target_month_proposal_total_matching_count
 */
AgentMetrics.prototype['target_month_proposal_total_matching_count'] = undefined;

/**
 * @member {Number} target_month_match_rate_for_business_meeting
 */
AgentMetrics.prototype['target_month_match_rate_for_business_meeting'] = undefined;

/**
 * @member {Number} target_month_proposal_user_read_rate
 */
AgentMetrics.prototype['target_month_proposal_user_read_rate'] = undefined;

/**
 * @member {Number} target_month_proposal_inflow_user_user_read_count
 */
AgentMetrics.prototype['target_month_proposal_inflow_user_user_read_count'] = undefined;

/**
 * @member {Number} target_month_proposal_inflow_user_user_read_rate
 */
AgentMetrics.prototype['target_month_proposal_inflow_user_user_read_rate'] = undefined;

/**
 * @member {Number} target_month_proposal_matching_rate
 */
AgentMetrics.prototype['target_month_proposal_matching_rate'] = undefined;

/**
 * @member {Number} target_month_proposal_inflow_user_matching_count
 */
AgentMetrics.prototype['target_month_proposal_inflow_user_matching_count'] = undefined;

/**
 * @member {Number} target_month_proposal_inflow_user_matching_rate
 */
AgentMetrics.prototype['target_month_proposal_inflow_user_matching_rate'] = undefined;

/**
 * @member {Number} target_month_contract_application_rate
 */
AgentMetrics.prototype['target_month_contract_application_rate'] = undefined;

/**
 * @member {Number} target_month_access_count
 */
AgentMetrics.prototype['target_month_access_count'] = undefined;

/**
 * @member {Number} target_month_daily_average_access_count
 */
AgentMetrics.prototype['target_month_daily_average_access_count'] = undefined;

/**
 * @member {Number} target_month_contract_inflow_user_application_count
 */
AgentMetrics.prototype['target_month_contract_inflow_user_application_count'] = undefined;

/**
 * @member {Number} target_month_contract_inflow_user_application_rate
 */
AgentMetrics.prototype['target_month_contract_inflow_user_application_rate'] = undefined;






export default AgentMetrics;

